import Card from "react-bootstrap/Card";

function SectionCard({ title, action = null, children }) {
  return (
    <Card className="section-card">
      <Card.Body style={{color: "white"}}>
        {action ? (
          <div className="bg-dark d-flex justify-content-between align-items-center mb-3">
            <Card.Title className="m-0">{title}</Card.Title>
            {action}
          </div>
        ) : (
          <Card.Title>{title}</Card.Title>
        )}
        {children}
      </Card.Body>
    </Card>
  );
}

export default SectionCard;
